// import axios from 'axios'
import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'
import { formSubmitClear, formComplete } from 'actions/forms'

export const MANAGE_PERMISSIONS_GETING_ADMIN_USERS = 'MANAGE_PERMISSIONS_GETING_ADMIN_USERS'
export const MANAGE_PERMISSIONS_RECEIVED_ADMIN_USERS = 'MANAGE_PERMISSIONS_RECEIVED_ADMIN_USERS'
export const MANAGE_PERMISSIONS_GETING_ROLES = 'MANAGE_PERMISSIONS_GETING_ROLES'
export const MANAGE_PERMISSIONS_RECEIVED_ROLES = 'MANAGE_PERMISSIONS_RECEIVED_ROLES'
export const MANAGE_PERMISSIONS_SAVE_USER_START = 'MANAGE_PERMISSIONS_SAVE_USER_START'
export const MANAGE_PERMISSIONS_SAVE_USER_COMPLETE = 'MANAGE_PERMISSIONS_SAVE_USER_COMPLETE'

const getAdminUsers = () => ({
  type: MANAGE_PERMISSIONS_GETING_ADMIN_USERS,
})

const receiveAdminUsers = adminUsers => ({
  type: MANAGE_PERMISSIONS_RECEIVED_ADMIN_USERS,
  adminUsers,
})

const getRoles = () => ({
  type: MANAGE_PERMISSIONS_GETING_ROLES,
})

const receiveRoles = roles => ({
  type: MANAGE_PERMISSIONS_RECEIVED_ROLES,
  roles,
})

const saveUserStart = () => ({
  type: MANAGE_PERMISSIONS_SAVE_USER_START,
})

const saveUserComplete = () => ({
  type: MANAGE_PERMISSIONS_SAVE_USER_COMPLETE,
})

export function loadAdminUsers(currentUserId) {
  return (dispatch) => {
    dispatch(getAdminUsers())
    agent.ManagePermissions.getAdminUsers(currentUserId).then((response) => {
      dispatch(receiveAdminUsers(response))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <loadAdminUsers>: ', description, error)
      }
    })
  }
}

export function loadRoles(currentUserId) {
  return (dispatch) => {
    dispatch(getRoles())
    agent.ManagePermissions.getAdminRoles(currentUserId).then((response) => {
      dispatch(receiveRoles(response))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <loadRoles>: ', description, error)
      }
    })
  }
}

export function addAdminUser(data, currentUserId, formId) {
  return (dispatch) => {
    dispatch(saveUserStart())
    agent.ManagePermissions.addAdminUser(data, currentUserId).then((response) => {
      dispatch(saveUserComplete())
      dispatch(notify('User permission saved'))
      dispatch(formComplete(formId))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify('Error adding user, please try again later'))
        dispatch(formSubmitClear(formId))
        // console.warn('Err <addAdminUser>: ', description, error)
      }
    })
  }
}

export function editAdminUser(data, currentUserId, formId) {
  return (dispatch) => {
    dispatch(saveUserStart())
    agent.ManagePermissions.editAdminUser(data, currentUserId).then((response) => {
      dispatch(saveUserComplete())
      dispatch(notify('User permission saved'))
      dispatch(formComplete(formId))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify('Error updating user, please try again later'))
        dispatch(formSubmitClear(formId))
        // console.warn('Err <updateAdminUser>: ', description, error)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/managePermissions.js